<template>
  <div class="form-builder">
    <div v-show="showSuccessMessage" class="no-line text-left success-message-wrapper">
      <div class="success-message" v-html="successMessage"></div>
    </div>
    <md-content>
      <viewer
        :nid="nuuid"
        :sid="suuid"
        :draft_sid="draft_suuid"
        field="activity_form"
        @set-sid="suuid = $event"
        :elements="elements"
        @change-status="status = $event"
      />
    </md-content>
  </div>
</template>

<script>
import Viewer from "./views/Viewer.vue";
import HelpersMixin from './HelpersMixin'
export default {
  name: "Temporary",
  props: ["mode", "nid", "sid", "noTemplate"],
  mixins: [HelpersMixin],
  created() {
    if (!window.drupalSettings.hasOwnProperty('form_builder')) {
      return;
    }

    let nodes = Object.keys(window.drupalSettings.form_builder);
    if (nodes.length) {
      this.nuuid = nodes[0];
      this.$emit("set-nid", this.nuuid);
      let submissions = Object.keys(
        window.drupalSettings.form_builder[this.nuuid].submissions
      ).forEach(submission => {
        if (
          window.drupalSettings.form_builder[this.nuuid].submissions[submission]
            .isDraft == true
        ) {
          this.draft_suuid = submission;
        }
        if (
          !window.drupalSettings.form_builder[this.nuuid].submissions[
            submission
          ].isDraft
        ) {
          this.suuid = submission;
        }
      });
      let components =
        window.drupalSettings.form_builder[this.nuuid].tabs["activity_form"]
          .data;
      if (components.length) {
        this.elements = components;
      }
    }
  },
  data() {
    return {
      showNavigation: false,
      view_mode: this.mode || false,
      dev_mode: window.webpackHotUpdate,
      nuuid: this.nid || "",
      suuid: this.sid || "",
      elements: null,
      draft_suuid: null,
      status: '',
      showSuccessMessage: false,
      successMessage: "",
    };
  },
  components: {
    Viewer
  },
  watch: {
    status(newStatus) {
      this.$emit("change-status", newStatus);
    }
  },
  methods: {
    getToken() {
      return fetch("/session/token?t=" + Date.now(), {
        credentials: "include"
      })
        .then(response => {
          return response.text();
        })
        .then(text => {
          this.token = text;
          return text;
        });
    }
  },
  mounted() {
    this.showAssignmentMessage();
    this.clearAssignmentStorage();
  },
};
</script>

<style lang="scss">
.md-menu-content {
  z-index: 103 !important;
}


.text-left {
  text-align: left;
}
.form-builder {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
  text-align: center;
  color: #2c3e50;
  //overflow: hidden;
  position: relative;
  label {
    font-weight: 400;
  }
}
.md-dialog {
  label {
    font-weight: 400;
  }
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.success-message {
  display: block!important;
}
</style>
